import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip, Icon } from '@sravni/react-design-system';
import { Tooltip as Tooltip$1 } from '@sravni/react-icons/dist/esm/generated/Tooltip';
import modules_c1e2d868 from './CardSummary.module.scss.js';

var CardSummary = function (_a) {
    var label = _a.label, tooltip = _a.tooltip, value = _a.value;
    return jsxs("div", { className: modules_c1e2d868.root, children: [jsxs("div", { className: modules_c1e2d868.label, children: [jsxs("span", { children: [label, "\u00A0"] }), tooltip && jsx(Tooltip, { footer: tooltip, placement: "right", children: jsx(Icon, { size: 16, className: modules_c1e2d868.tooltip, icon: jsx(Tooltip$1, {}) }) })] }), jsx("div", { className: modules_c1e2d868.value, children: value })] });
};

export { CardSummary };
//# sourceMappingURL=CardSummary.js.map
